import { render, staticRenderFns } from "./BoardListSearchLayout.vue?vue&type=template&id=3e5dea18&scoped=true&"
import script from "./BoardListSearchLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListSearchLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5dea18",
  null
  
)

export default component.exports